var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('a-tabs',[_vm._l((_vm.bookNames),function(b){return _c('a-tab-pane',{key:b,attrs:{"tab":b}},[_c('Product',{attrs:{"bookName":b,"isAdmin":_vm.isAdmin}})],1)}),(_vm.isAdmin)?_c('a-tab-pane',{key:"admin",attrs:{"tab":"管理员"}},[_c('Admin')],1):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }